module.exports = __webpack_public_path__ + "static/media/SparkasseRg.7b257ba8.eot";